import { CartLinesUpdateEvent } from '@shopify/events';

function addItems(trigger, items, errEl, cartAddUrl, cartUrl) {
  var sections = [];
  document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) sections.push(c.dataset.sectionId); });
  var deferred = CartLinesUpdateEvent.createPromise();
  trigger.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
    promise: deferred.promise
  }));
  trigger.disabled = true;
  if (errEl) errEl.textContent = '';
  return fetch(cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: sections.join(',') }) })
    .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
    .then(function (added) {
      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'slippy', sourceId: 'slippy', itemCount: cart.item_count, sections: added.sections, didError: false } });
        trigger.disabled = false;
        if (!document.querySelector('cart-drawer-component')) window.location.href = cartUrl;
      });
    })
    .catch(function (d) {
      deferred.reject(d);
      trigger.disabled = false;
      if (errEl) errEl.textContent = (d && (d.description || d.message)) || 'Something went wrong. Please try again.';
    });
}

function money(cents, format) {
  var v = (cents / 100).toFixed(2);
  var c = v.replace('.', ',');
  var f = format || '{{amount}}';
  return f.split('{{amount_with_comma_separator}}').join(c).split('{{ amount_with_comma_separator }}').join(c).split('{{amount}}').join(v).split('{{ amount }}').join(v);
}

document.querySelectorAll('[data-sl-product]').forEach(function (root) {
  var product = JSON.parse(root.querySelector('[data-product-json]').textContent);
  var cartAddUrl = root.dataset.cartAdd + '.js';
  var cartUrl = root.dataset.cartUrl;
  var slides = root.querySelectorAll('[data-slide]');
  var thumbs = root.querySelectorAll('[data-thumb]');
  var active = 0;
  function show(i) {
    if (!slides.length) return;
    active = (i + slides.length) % slides.length;
    slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === active); });
    thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === active); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.thumb, 10)); }); });
  var prev = root.querySelector('[data-prev]');
  var next = root.querySelector('[data-next]');
  if (prev) prev.addEventListener('click', function () { show(active - 1); });
  if (next) next.addEventListener('click', function () { show(active + 1); });

  function findVariant(values) {
    return product.variants.find(function (v) { return values.every(function (val, j) { return v.options[j] === val; }); }) || null;
  }
  function rowVariant(row) {
    var values = [];
    row.querySelectorAll('select[data-option]').forEach(function (s) { values[parseInt(s.dataset.option, 10)] = s.value; });
    return findVariant(values);
  }
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-option]');
    if (!sel) return;
    var v = rowVariant(sel.closest('[data-row]'));
    if (v && v.featured_media) slides.forEach(function (s, idx) { if (String(s.dataset.mediaId) === String(v.featured_media.id)) show(idx); });
  });

  var tiers = root.querySelectorAll('[data-tier]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  function selectTier(tier) {
    tiers.forEach(function (t) { var on = t === tier; t.classList.toggle('is-selected', on); t.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var p = tier.querySelector('.sl-tier__price');
    if (p && stickyPrice) stickyPrice.textContent = p.textContent;
  }
  tiers.forEach(function (t) {
    t.addEventListener('click', function (e) { if (!e.target.closest('select, label')) selectTier(t); });
    t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectTier(t); } });
  });

  var atc = root.querySelector('[data-atc]');
  var err = root.querySelector('[data-error]');
  if (atc) atc.addEventListener('click', function () {
    var tier = root.querySelector('[data-tier].is-selected') || tiers[0];
    var counts = {};
    var missing = false;
    tier.querySelectorAll('[data-row]').forEach(function (row) {
      var v = rowVariant(row);
      if (!v || !v.available) { missing = true; return; }
      counts[v.id] = (counts[v.id] || 0) + 1;
    });
    if (missing) { err.textContent = 'One of your picks is unavailable. Please choose another color or size.'; return; }
    var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
    root.querySelectorAll('[data-addon]').forEach(function (cb) { if (cb.checked) items.push({ id: parseInt(cb.dataset.addon, 10), quantity: 1 }); });
    addItems(atc, items, err, cartAddUrl, cartUrl);
  });

  var sticky = root.querySelector('[data-sticky]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    var btn = sticky.querySelector('[data-sticky-btn]');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var on = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }).observe(atc);
    btn.addEventListener('click', function () { atc.click(); });
  }
});

document.querySelectorAll('[data-sl-fbt]').forEach(function (root) {
  var fmt = root.dataset.moneyFormat;
  var totalEl = root.querySelector('[data-fbt-total]');
  var compareEl = root.querySelector('[data-fbt-compare]');
  function selected(item) {
    var sel = item.querySelector('select');
    return sel ? sel.options[sel.selectedIndex] : item.querySelector('[data-variant]');
  }
  function update() {
    var total = 0, compare = 0;
    root.querySelectorAll('[data-fbt-item]').forEach(function (item) {
      var cb = item.querySelector('input[type=checkbox]');
      var opt = selected(item);
      var price = parseInt(opt.dataset.price, 10);
      var cmp = parseInt(opt.dataset.compare || opt.dataset.price, 10);
      var p = item.querySelector('[data-fbt-price]');
      if (p) p.textContent = money(price, fmt);
      if (cb.checked) { total += price; compare += Math.max(cmp, price); }
    });
    totalEl.textContent = money(total, fmt);
    if (compareEl) compareEl.textContent = compare > total ? money(compare, fmt) : '';
  }
  root.addEventListener('change', update);
  update();
  var btn = root.querySelector('[data-fbt-add]');
  var err = root.querySelector('[data-error]');
  btn.addEventListener('click', function () {
    var items = [];
    root.querySelectorAll('[data-fbt-item]').forEach(function (item) {
      var cb = item.querySelector('input[type=checkbox]');
      var opt = selected(item);
      if (cb.checked && opt.dataset.available !== 'false') items.push({ id: parseInt(opt.value || opt.dataset.variant, 10), quantity: 1 });
    });
    if (!items.length) return;
    addItems(btn, items, err, root.dataset.cartAdd + '.js', root.dataset.cartUrl);
  });
});